module.exports = __webpack_public_path__ + "media/images/shared/rules-cover-dd061d6915327f9401ad0a3d16c3ed58.jpg";